import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_11_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-11-01",
    "name": "胸部热身",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "chest",
    "tips": ["胸部肌群动态激活", "俯卧撑变体"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/6fb3790071c48a55043ff607.mp4",
    "videoUrl": "/media/collections-20261008/videos/f24f6578819f5e68059f3dda.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第11期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-11-02",
    "name": "上斜史密斯",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "upper-chest",
    "tips": ["史密斯轨迹稳定", "侧重上胸"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-e7605395a7208568223eb74e.mp4",
    "videoUrl": "/media/collections-20261008/videos/reviewed-b72a9000f195d6d4234494ab.mp4",
    "targetMuscles": ["上胸肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第11期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-11-03",
    "name": "上斜推胸",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "upper-chest",
    "tips": ["器械上斜推胸", "顶峰收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/67365ea825d5b71d59e9ee64.mp4",
    "videoUrl": "/media/collections-20261008/videos/fe69b79a1187f65e7e2bb0d6.mp4",
    "targetMuscles": ["上胸肌", "胸大肌", "三角肌前束", "肱三头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第11期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-11-04",
    "name": "坐姿夹胸",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "mid-chest",
    "tips": ["顶峰收缩1秒", "控制回放速度"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/711b6d247c79853483111a50.mp4",
    "videoUrl": "/media/collections-20261008/videos/3f847889de66eb9a85728c28.mp4",
    "targetMuscles": ["胸大肌中缝", "胸大肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第11期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-11-05",
    "name": "飞鸟夹胸",
    "bodyPart": "chest",
    "equipment": "machine",
    "subCategory": "inner-chest",
    "tips": ["顶峰收缩1秒", "控制回放速度"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-d10dd865e09835b65d50ca1d.mp4",
    "videoUrl": "/media/collections-20261008/videos/reviewed-268eae0b28d491dcb564ef23.mp4",
    "targetMuscles": ["胸大肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第11期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-11-06",
    "name": "单臂哑铃侧平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "side-deltoid",
    "tips": ["肘微屈，侧抬与肩齐平", "控制下放"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "焚诀计划 · 第11期",
    "demoUrl": "/media/collections-20261008/demos/af0160ddf2a449a49182f6c8.mp4",
    "videoUrl": "/media/collections-20261008/videos/cf7fb44affefee553504cdfc.mp4",
    "targetMuscles": ["三角肌中束"],
    "difficulty": "intermediate",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-11-07",
    "name": "双杠臂屈伸",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "lower-chest",
    "tips": ["身体前倾重心前移，侧重下胸", "下放至大臂平行于地面或略低"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["下胸肌", "胸大肌"],
    "source": "焚诀计划 · 第11期",
    "demoUrl": "/media/collections-20261008/demos/e6c628fad6ed96b83987d285.mp4",
    "videoUrl": "/media/collections-20261008/videos/5e03dfaab65927a9226c5396.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
